import { HttpClient } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { Auth } from '@app/interfaces/sys/auth';
import { Menu } from '@app/interfaces/sys/menu';
import { Permission } from '@app/interfaces/sys/permission';
import { lastValueFrom } from 'rxjs';
import { TokenService } from './token.service';
import { RoleService } from './role.service';
import { Router } from '@angular/router';
import { basicRoleFeatures } from '@app/core/startup/permission';
import { getMenu } from '@app/core/startup/menu';

@Injectable({
    providedIn: 'root',
})
export class PermissionService {
    constructor(private http: HttpClient,
        private injector: Injector,
        private tokenService: TokenService,
        private roleService: RoleService,) { }

    async find(): Promise<Permission[]> {
        return lastValueFrom(this.http.get<Permission[]>('/permissions/all'));
    }

    getUserPermissions(): string[] {
        const tokenData: Auth = this.tokenService.get();
        const userPermissions = tokenData && tokenData.features ? tokenData.features : {};
        let allPermissions = {};
        const adminRole = 'Admin';
        if (this.roleService.isAdmin(tokenData.roleNames || [])) {
            allPermissions = basicRoleFeatures[adminRole?.toLowerCase()]?.features ?? {};
        } else {
            allPermissions = {
                ...userPermissions,
            };
        }
        return allPermissions ? Object.keys(allPermissions) : [];
    }

    getCurrentMenu(): Menu[] {
        const tokenData: Auth = this.tokenService.get();

        if (!tokenData?.token) {
            this.injector.get(Router).navigateByUrl('/login');
            return [];
        }

        const userPermissions = this.getUserPermissions();

        const menus = getMenu(userPermissions, tokenData.roleNames);
        return menus;
    }
    
}
